import React from "react"
import { ApolloProvider } from "react-apollo"
import { client } from "./src/apollo/client"
import { Provider as ReduxProvider } from "react-redux"
import { createStore as reduxCreateStore } from "redux"
import { rootReducer } from "./src/state"

import { clearSessionStorage } from "./src/utils/general"
import "./src/utils/global.scss"

const createStore = () => reduxCreateStore(rootReducer)
export function wrapRootElement({ element }) {
  return (
    <ApolloProvider client={client}>
      <ReduxProvider store={createStore()}>
        {element}
      </ReduxProvider>
    </ApolloProvider>
  )
}

export function onClientEntry() {
  // clean sessionStorage on any index page browser entry
  if (typeof window !== `undefined`) {
    let location = window.location.pathname
    if (location === "/" || location === "/hair/men/quiz/") {
      clearSessionStorage()
    }
  }
}

export function onPreRouteUpdate() {
  if (window.Yo) {
    window.Yo.pubsub.publish({ topic: "rum/spa/transition/start", message: {} })
  }
}

export function onRouteUpdate({ location, prevLocation }) {
  // ### stuff from previous quiz onRouteUpdate functino: ###
  window.locations = window.locations || [document.referrer]
  window.locations.push(window.location.href)
  window.previousPath = window.locations[window.locations.length - 2]
  // ### ### ### ### ### ### ### ### ### ### ### ### ### ### ###

  const fireGatsbyRouteChange = num => {
    if (
      typeof window !== "undefined" &&
      typeof window.dataLayer !== "undefined"
    ) {
      window.dataLayer.push({ event: "gatsby-route-change" })
    } else {
      if (num < 10) {
        setTimeout(
          () => {
            let newNum = num + 1
            fireGatsbyRouteChange(newNum)
          },
          500,
          num
        )
      }
    }
  }

  fireGatsbyRouteChange(0)

  if (window.Yo && !!prevLocation) {
    window.Yo.pubsub.publish({
      topic: "rum/spa/rendered",
      message: {
        viewType: "TRANSITION", // TRANSITION BC NOT FIRST LOAD
      },
    })
  }

  // Track segment analytic page views
  setTimeout(() => {
    if (window.analytics && window.analytics.page) {
      window.analytics.page(document.title, {
        userAgent: navigator.userAgent,
        business_line: "Hair",
      })
    }
  }, 1000)
}

// runs on initial client render "CLEAN"
export function onInitialClientRender() {

  let location = window.location.pathname

  const initialYoViewClean = num => {
    if (window.Yo && location) {
      window.Yo.pubsub.publish({
        topic: "rum/spa/rendered",
        message: {
          viewType: "CLEAN", // CLEAN BC FIRST LOAD ONLY
        },
      })
    } else {
      if (num < 10) {
        setTimeout(
          () => {
            let newNum = num + 1
            initialYoViewClean(newNum)
          },
          500,
          num
        )
      }
    }
  }

  const addSegmentMiddleware = num => {
    if (window.analytics) {
      const addUserAgentDataToTrack = ({ payload, next }) => {
        if (!!payload && !!payload.obj && !!payload.obj.properties) {
          payload.obj.properties.userAgent = navigator.userAgent
        }
        next(payload)
      }
      window.analytics.addSourceMiddleware(addUserAgentDataToTrack)
    } else {
      if (num < 10) {
        setTimeout(
          () => {
            let newNum = num + 1
            addSegmentMiddleware(newNum)
          },
          500,
          num
        )
      }
    }
  }

  setTimeout(() => {
    initialYoViewClean(0)
    addSegmentMiddleware(0)
  }, 1000)
}

// VWO Segment Integration code
window.VWO = window.VWO || []

window.VWO.push([
  "onEventReceive",
  "vA",
  function(data) {
    // To fetch A/B test id
    var experimentId = data[1]
    // To fetch A/B test active variation name
    var variationId = data[2]
    // To get A/B test name
    var abTestName = window._vwo_exp[experimentId].name
    // To get A/B test active variation name
    var variationName = window._vwo_exp[experimentId].comb_n[variationId]

    if (
      typeof window._vwo_exp[experimentId].comb_n[variationId] !==
        "undefined" &&
      ["VISUAL_AB", "VISUAL", "SPLIT_URL", "SURVEY"].indexOf(
        window._vwo_exp[experimentId].type
      ) > -1
    ) {
      if (
        window.analytics &&
        experimentId &&
        abTestName &&
        variationId &&
        variationName
      ) {
        setTimeout(() => {
          window.analytics.track("Experiment Viewed", {
            experiment_id: experimentId,
            experiment_name: abTestName,
            page_title: document.title,
            page_url: window.location.href,
            userAgent: navigator.userAgent,
            variant_name: variationName,
          })
        }, 1000)
      }
    }
  },
])
